module.exports = __webpack_public_path__ + "media/images/comment-manager2-688a2349.png";